import axios from "axios";
import { BASE_URL } from "./constants";

export type ClickedOn = "email" | "whatsapp" | "call" | "sms" | "fb_messenger" | "instagram" | "wechat";
export type ClickSource = "homepage" | "widget";

export const trackClick = async (
  clientCode: string,
  clickedOn: ClickedOn,
  clickSource: ClickSource
): Promise<void> => {
  try {
    await axios.post(
      `${BASE_URL}/fe/click_track/${clientCode}?clicked_on=${clickedOn}&click_source=${clickSource}`
    );
  } catch (error) {
    console.error("Failed to track click:", error);
  }
};
